import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ConfirmationModel } from "../models/confirmation.model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ConfirmationService {
  private baseRoute: string;
  constructor(private httpClient: HttpClient){
    this.baseRoute = environment.formbuilderAPIUrlRoot;
  }

  getConfirmationsByFormId<T>(formId : string = ''): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}/getallconfirmationbyformid/${formId}`);
  }

  getAllConfirmations<T>(): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}/getallconfirmation`);
  }

  upsertConfirmation(data: ConfirmationModel){
    return this.httpClient.post(`${this.baseRoute}/upsertconfirmation`, data);
  }

  getConfirmationById(id: number){
    return this.httpClient.delete(`${this.baseRoute}/getconfirmationbyid/${id}`);
  }

  deleteConfirmation(id: number, userId: number){
    return this.httpClient.delete(`${this.baseRoute}/deleteconfirmation/${id}/${userId}`);
  }
}
